import { render, staticRenderFns } from "./PageBuilderSlot.vue?vue&type=template&id=23bfd953"
import script from "./PageBuilderSlot.vue?vue&type=script&lang=js"
export * from "./PageBuilderSlot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports